<template>
  <div class="flex items-center gap-6 lg:gap-14">
    <button
      type="button"
      class="inline-flex items-center"
      :class="{
        'opacity-50 cursor-not-allowed transition-opacity duration-300':
          !previousWeekId
      }"
      :disabled="!previousWeekId"
      @click="changeWeek(previousWeekId)"
    >
      <span
        class="
          flex-shrink-0 flex
          justify-center
          items-center
          w-[4.489rem]
          h-[4.489rem]
          bg-blue
          rounded-full
          lg:w-14 lg:h-14 lg:rounded-10px
        "
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="w-1/2 text-white"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M15 19l-7-7 7-7"
          />
        </svg>
      </span>
      <span class="hidden ml-4 lg:block">{{ __('btn_previous_week') }}</span>
    </button>

    <div class="lg:hidden">{{ __('week') }}</div>

    <button
      type="button"
      class="inline-flex items-center transition-opacity duration-300"
      :class="{ 'opacity-50 cursor-not-allowed': !nextWeekId }"
      :disabled="!nextWeekId"
      @click="changeWeek(nextWeekId)"
    >
      <span class="hidden mr-4 lg:block">{{ __('btn_next_week') }}</span>
      <span
        class="
          flex-shrink-0 flex
          justify-center
          items-center
          w-[4.489rem]
          h-[4.489rem]
          bg-blue
          rounded-full
          lg:w-14 lg:h-14 lg:rounded-10px
        "
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="w-1/2 text-white"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M9 5l7 7-7 7"
          />
        </svg>
      </span>
    </button>
  </div>
</template>

<script>
import { ref, watchEffect } from 'vue';
import { loadData, weeks } from '@/stores/Rooms';

export default {
  setup() {
    const previousWeekId = ref(null);
    const nextWeekId = ref(null);

    watchEffect(() => {
      const selectedWeekIndex = weeks.value.findIndex(
        (week) => week.selected === true
      );
      if (selectedWeekIndex > -1) {
        previousWeekId.value =
          (weeks.value[selectedWeekIndex - 1] &&
            weeks.value[selectedWeekIndex - 1].id) ||
          null;
        nextWeekId.value =
          (weeks.value[selectedWeekIndex + 1] &&
            weeks.value[selectedWeekIndex + 1].id) ||
          null;
      }
    });

    const changeWeek = async (weekId) => {
      await loadData(weekId);
    };

    return {
      previousWeekId,
      nextWeekId,
      changeWeek
    };
  }
};
</script>
